import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enProfile from './locales/en/profile.json';
import enTable from './locales/en/table.json';
import enSettings from './locales/en/settings.json';
import enSidebar from './locales/en/sidebar.json';
import enLanguage from './locales/en/language.json';
import enAuditLogs from './locales/en/auditLogs.json';
import enOnboarding from './locales/en/onboarding.json';
import enBilling from './locales/en/billing.json';
import enCheckout from './locales/en/checkout.json';
import enCompany from './locales/en/company.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frProfile from './locales/fr/profile.json';
import frTable from './locales/fr/table.json';
import frSettings from './locales/fr/settings.json';
import frSidebar from './locales/fr/sidebar.json';
import frLanguage from './locales/fr/language.json';
import frAuditLogs from './locales/fr/auditLogs.json';
import frOnboarding from './locales/fr/onboarding.json';
import frBilling from './locales/fr/billing.json';
import frCheckout from './locales/fr/checkout.json';
import frCompany from './locales/fr/company.json';

// Merge all translations into a single object
const enTranslations = {
  common: enCommon,
  navigation: enNavigation,
  auth: enAuth,
  dashboard: enDashboard,
  profile: enProfile,
  table: enTable,
  settings: enSettings,
  sidebar: enSidebar,
  language: enLanguage,
  auditLogs: enAuditLogs,
  onboarding: enOnboarding,
  billing: enBilling,
  checkout: enCheckout,
  company: enCompany,
};

const frTranslations = {
  common: frCommon,
  navigation: frNavigation,
  auth: frAuth,
  dashboard: frDashboard,
  profile: frProfile,
  table: frTable,
  settings: frSettings,
  sidebar: frSidebar,
  language: frLanguage,
  auditLogs: frAuditLogs,
  onboarding: frOnboarding,
  billing: frBilling,
  checkout: frCheckout,
  company: frCompany,
};

const resources = {
  en: {
    translation: enTranslations,
  },
  fr: {
    translation: frTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
